import deploymentConfig from "../deployment.config";
import { EventName, TrackingEvent } from "./tracking.types";
import packageInfo from '../../package.json';


export function getPiDomain(apiUrl: string) {
  return apiUrl.includes('/api') ? `${apiUrl}/telemetry`: `${apiUrl}/api/telemetry`;
}
const sourceAppEnv =
  deploymentConfig.environment !== "production"
    ? `-${deploymentConfig.environment}`
    : "";

export const defaultTrackingDataConfig: TrackingEvent = {
  eventName: EventName.UNKNOWN,
  projectInfo: {
    projectId: "lmp-tools",
    secret: "test",
  },
  nonPiiData: {
    "external-source": {
      "source-app": `adm${sourceAppEnv}`,
      source: "adm",
    },
    "frontend-version": packageInfo.version,
  },
  piiData: {
  },
};

